import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_POST_AGENT_SEARCH } from "../../Apis/ApiEndPoints";
import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import { IPostGlobalSearchRequestParams } from "../../models/agent/Search/globalSearch";

export const AgentGlobalSearch = createAsyncThunk(
  "search/agentGlobalSearch",
  async (requestParams: IPostGlobalSearchRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_AGENT_SEARCH, requestParams),
      dispatch,
      "search/agentGlobalSearch"
    );
    return response;
  }
);
